import Facility from './Facility';

export default Facility;
